export default "__VITE_ASSET__DNJ6TOuG__"